import { TransferReportDay } from "@/types";

export function prepareOverviewChartData(transferReport: TransferReportDay[] | undefined): {
  labels: string[];
  data: number[];
} {
  const sorted = transferReport
    ? [...transferReport].sort((a, b) => new Date(a.day).getTime() - new Date(b.day).getTime())
    : [];

  const labels = sorted.map((transferDay) => {
    const utcMonth = new Date(transferDay.day).toLocaleDateString("en-US", {
      month: "short",
      timeZone: "UTC",
      timeZoneName: undefined,
    });
    const utcDay = new Date(transferDay.day).toLocaleDateString("en-US", {
      day: "numeric",
      timeZone: "UTC",
      timeZoneName: undefined,
    });
    return `${utcMonth}. ${utcDay}`;
  });

  const data = sorted.map((transferDay) => transferDay.total_rows_transferred);

  return { labels, data };
}
